(function () {
    const head = document.querySelector('.gh-head');
    if (!head) return;

    const toggleScrolled = function () {
        head.classList.toggle('is-scrolled', window.scrollY > 4);
    };

    toggleScrolled();
    window.addEventListener('scroll', toggleScrolled, {passive: true});
})();
